// extracted by mini-css-extract-plugin
module.exports = {"faqQuestion":"Faq__faqQuestion___34I7I","useWFFonts":"Faq__useWFFonts___1r3p4","faqQuestionText":"Faq__faqQuestionText___2MTue","faqAnswer":"Faq__faqAnswer___38JzY"};